var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BFormInput',_vm._g(_vm._b({attrs:{"state":_vm.input_state,"value":_vm.value}},'BFormInput',_vm.$attrs,false),_vm.inputListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }